import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Typography, Tooltip } from 'antd';
import {
  EmailShareButton,
  FacebookShareButton,
  TwitterShareButton,
  WhatsappShareButton
} from 'react-share';
import { FacebookIcon, GmailIcon, TwitterIcon, WhatsappIcon } from 'utils/icons';
import { CopyOutlined } from '@ant-design/icons';
import trackingService from 'services/trackingService';
import EVENT_NAME from 'utils/const';
import referalCardImage from 'assets/icons/referal_card.svg';

function ReferralCard({ refCode }) {
  const referralLink = `${process.env.REACT_APP_EBZ_URL}merchant/signup/${refCode}`;

  const [copiedField, setCopiedField] = useState(null);

  const handleCopy = (text, label) => {
    navigator.clipboard.writeText(text);
    setCopiedField(label);
    trackingService.trackEvent(EVENT_NAME.BUTTON_CLICK, {
      name: `Copy ${label}`
    });

    setTimeout(() => setCopiedField(null), 1500);
  };

  return (
    <div
      style={{
        position: 'relative',
        width: 'fit-content',
        margin: '0 auto',
        border: 'none',
        background: 'transparent'
      }}
    >
      <div
        style={{
          backgroundImage: `url(${referalCardImage})`,
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          borderRadius: '20px',
          padding: '0 24px',
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'column',
          gap: '8px',
          height: '340px',
          boxShadow: '0px 2px #e4d9e094'
        }}
      >
        <div style={{ marginTop: '100px' }}>
          <Typography.Text style={{ fontSize: '14px', color: '#888' }}>
            Your referral code
          </Typography.Text>
          <div
            style={{
              backgroundColor: '#f2f2f2',
              borderRadius: '6px',
              padding: '8px 12px',
              marginTop: '2px',
              alignItems: 'center',
              fontWeight: 700,
              fontSize: '12px'
            }}
          >
            {refCode}
            <Tooltip
              title={copiedField === 'Referral Code' ? 'Copied!' : 'Copy'}
              placement="top"
              overlayStyle={{ fontSize: '12px' }}
            >
              <CopyOutlined
                onClick={() => handleCopy(refCode, 'Referral Code')}
                style={{
                  cursor: 'pointer',
                  color: 'var(--color-primary)',
                  marginLeft: '4px'
                }}
              />
            </Tooltip>
          </div>
        </div>

        <div>
          <Typography.Text style={{ fontSize: '14px', color: '#888' }}>
            Your referral link
          </Typography.Text>
          <div
            style={{
              backgroundColor: '#f2f2f2',
              borderRadius: '6px',
              padding: '8px 12px',
              marginTop: '4px',
              alignItems: 'center',
              fontWeight: 700,
              fontSize: '12px'
            }}
          >
            Referral Link
            <Tooltip
              title={copiedField === 'Referral Link' ? 'Copied!' : 'Copy'}
              placement="top"
              overlayStyle={{ fontSize: '12px' }}
            >
              <CopyOutlined
                onClick={() => handleCopy(referralLink, 'Referral Link')}
                style={{
                  cursor: 'pointer',
                  color: 'var(--color-primary)',
                  marginLeft: '4px'
                }}
              />
            </Tooltip>
          </div>
        </div>

        <div>
          <Typography.Text style={{ fontSize: '14px', color: '#888' }}>Share on</Typography.Text>
          <div
            style={{
              marginTop: '8px',
              display: 'flex',
              justifyContent: 'space-evenly',
              alignItems: 'center'
            }}
          >
            <WhatsappShareButton url={referralLink} title="Join Easebuzz with my referral link!">
              <WhatsappIcon style={{ fontSize: '54px' }} />
            </WhatsappShareButton>
            <EmailShareButton
              subject="Introducing Easebuzz"
              body="Join Easebuzz with my referral link!"
              url={referralLink}
              separator=" "
            >
              <GmailIcon style={{ fontSize: '54px' }} />
            </EmailShareButton>
            <FacebookShareButton
              url={referralLink}
              hashtag="#Easebuzz #Join_Easebuzz_With_My_Referral_Link!"
            >
              <FacebookIcon style={{ fontSize: '54px' }} />
            </FacebookShareButton>
            <TwitterShareButton
              url={referralLink}
              title="Join Easebuzz with my referral link!"
              hashtags={['Easebuzz']}
            >
              <TwitterIcon style={{ fontSize: '54px' }} />
            </TwitterShareButton>
          </div>
        </div>
      </div>
    </div>
  );
}

ReferralCard.propTypes = {
  refCode: PropTypes.string.isRequired
};

export default ReferralCard;
